module.exports = __webpack_public_path__ + "img/mic_off.dedd83d9.svg";